(ns dashboard.services.documents
  (:require [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]))

(rf/reg-event-fx
  ::delete
  (fn [_ [_ id filename]]
    {:http-xhrio {:method :delete
                  :uri (str "/api/policies/document/" id)
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success [::delete-success id filename]
                  :on-failure [::ui/set-error (str "Could not remove " filename)]}}))

(rf/reg-event-fx
  ::delete-success
  (fn [{:keys [db]} [_ id filename {:keys [result result-type]}]]
    (when result-type
      (js/alert (str "The document has evidence associated to it, and could not be deleted.\n"
                     "Instead the document has been moved to OBSOLETE documents.")))
    {:db (update-in db [:documents :data] #(remove (fn [document]
                                                     (= id (:id document)))
                                                   %))
     :dispatch [::notifications/add
                {:message (str filename " has been " result)}]}))

;; Subs

(rf/reg-sub
  ::documents
  (fn [db _]
    (:documents db)))

(rf/reg-sub
  ::loading
  :<- [::documents]
  (fn [documents _]
    (:loading documents)))

(rf/reg-sub
  ::data
  :<- [::documents]
  (fn [documents [_ sort-key sort-order]]
    (if (and sort-key sort-order)
      (sort-by sort-key
               (case sort-order
                 :asc compare
                 :desc #(compare %2 %1)
                 compare)
               (:data documents))
      (:data documents))))
